import {
    Directive,
    ElementRef,
    HostListener,
    Input,
    OnDestroy
} from '@angular/core';

@Directive({
    selector: '[cxTip]',
    standalone: true
})
export class CxTipDirective implements OnDestroy {
    @Input('cxTip') tip = '';

    private bubble?: HTMLDivElement;

    constructor(private el: ElementRef<HTMLElement>) { }

    private get isTouchDevice(): boolean {
        return window.matchMedia('(hover: none), (pointer: coarse)').matches;
    }

    private ensureBubble(): HTMLDivElement {
        if (!this.bubble) {
            this.bubble = document.createElement('div');
            this.bubble.className = 'cx-tip';
            this.bubble.setAttribute('role', 'tooltip');
            document.body.appendChild(this.bubble);
        }

        return this.bubble;
    }

    private positionBubble(b: HTMLDivElement): void {
        const rect = this.el.nativeElement.getBoundingClientRect();

        const x = rect.left;
        const y = rect.bottom + 8;

        b.style.left = `${Math.round(x)}px`;
        b.style.top = `${Math.round(y)}px`;
    }

    @HostListener('pointerenter', ['$event'])
    onPointerEnter(event: PointerEvent): void {
        if (event.pointerType === 'touch' || this.isTouchDevice) {
            return;
        }

        this.show();
    }

    @HostListener('focusin')
    onFocusIn(): void {
        if (this.isTouchDevice) {
            return;
        }

        this.show();
    }

    private show(): void {
        if (!this.tip) return;

        const b = this.ensureBubble();

        b.textContent = this.tip;
        b.style.display = 'block';

        this.positionBubble(b);
    }

    @HostListener('pointerleave')
    @HostListener('focusout')
    hide(): void {
        if (this.bubble) {
            this.bubble.style.display = 'none';
        }
    }

    @HostListener('window:scroll')
    @HostListener('window:resize')
    onViewportChange(): void {
        if (this.bubble && this.bubble.style.display === 'block') {
            this.positionBubble(this.bubble);
        }
    }

    ngOnDestroy(): void {
        if (this.bubble) {
            this.bubble.remove();
            this.bubble = undefined;
        }
    }
}